import Loading from '../../../../Dashboards/Common/Loading';
import { AvgPeoplePerFamilyAnual } from './AvgPeoplePerFamilyAnual';
import { AvgPeoplePerFamilyMonth } from './AvgPeoplePerFamilyMonth';
import { FamiliesAnual } from './FamiliesAnual';
import { FamiliesMonth } from './FamiliesMonth';
import { useCadUniqueChartsDataContext } from './hooks/useCadUniqueChartsDataContext';
import { PeopleAnual } from './PeopleAnual';
import { PeopleMonth } from './PeopleMonth';

export const Charts = () => {
    const { isLoading } = useCadUniqueChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <div className="charts-side-by-side-dashboards">
                <FamiliesAnual />
                <FamiliesMonth />
            </div> 
            <div className="charts-side-by-side-dashboards">
                <PeopleAnual />
                <PeopleMonth />
            </div> 
            <div className="charts-side-by-side-dashboards">
                <AvgPeoplePerFamilyAnual />
                <AvgPeoplePerFamilyMonth />
            </div> 
        </>
    );
};
